"use strict";
// Copyright © 2021 Move Closer
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmbedVideoSwitchAdapter = void 0;
const demarked_1 = require("@d24/demarked");
const adapter_1 = require("../../../_abstract/adapter");
const services_1 = require("../../../../services");
const _contracts_1 = require("../../../_contracts");
const adapter_2 = require("../../../_helpers/adapter");
const Embed_contracts_1 = require("../../Embed.contracts");
class EmbedVideoSwitchAdapter extends adapter_1.AbstractAdapter {
    objectToToken(object) {
        const { content } = object;
        this.validate(content, {
            description: {
                type: 'string'
            },
            video: {
                presence: false,
                type: 'object'
            },
            videoIdYoutube: {
                presence: false,
                type: 'string',
                length: { minimum: 1 }
            },
            videoIdOnHash: {
                presence: false,
                type: 'string',
                length: { minimum: 1 }
            },
            'video.type': adapter_1.getRelatedTypeConstraint(services_1.RelatedType.File, false),
            'video.value': adapter_1.getIdentifierConstraint(false)
        });
        if (typeof content.thumbnail !== 'undefined') {
            this.validate(content.thumbnail, {
                type: adapter_1.getRelatedTypeConstraint(services_1.RelatedType.File),
                value: adapter_1.getIdentifierConstraint()
            });
        }
        const { description, thumbnail, video, videoIdYoutube, videoIdOnHash } = content;
        const videoId = (video && video.value) ? video.value.toString() : undefined;
        if (!videoId && !videoIdYoutube && !videoIdOnHash) {
            throw new Error('one of [videoId, videoIdYoutube or videoIdOnHash] is required, but none was provided');
        }
        let meta = {};
        let raw = '#VIS[ ';
        const rawData = [];
        if (videoId) {
            rawData.push(`videoId: ${videoId}`);
        }
        if (videoIdYoutube) {
            rawData.push(`videoIdYoutube: ${videoIdYoutube}`);
        }
        if (videoIdOnHash) {
            rawData.push(`videoIdOnHash: ${videoIdOnHash}`);
        }
        if (typeof description === 'string' && description.length > 0) {
            meta = {
                ...meta,
                description
            };
            rawData.push(`description: ${description}`);
        }
        if (typeof thumbnail !== 'undefined' && typeof thumbnail.value === 'number') {
            const thumbnailId = thumbnail.value;
            if (typeof thumbnailId === 'number') {
                meta = {
                    ...meta,
                    thumbnailId
                };
                rawData.push(`thumbnailId: ${thumbnailId}`);
            }
        }
        raw += rawData.join(' | ');
        raw += ' ]';
        return {
            content: {
                videoId,
                videoIdYoutube,
                videoIdOnHash
            },
            raw,
            meta,
            type: demarked_1.TokenType.EmbedVideoSwitch
        };
    }
    tokenToObject(token) {
        this.validate(token, {
            'content.videoId': {
                presence: false,
                type: 'string',
                length: { minimum: 1 }
            },
            'content.videoIdYoutube': {
                presence: false,
                type: 'string',
                length: { minimum: 1 }
            },
            'content.videoIdOnHash': {
                presence: false,
                type: 'string',
                length: { minimum: 1 }
            }
        });
        if (typeof token.meta !== 'undefined') {
            this.validate(token.meta, {
                description: {
                    type: 'string'
                },
                thumbnailId: {
                    type: 'number'
                }
            });
        }
        const { content, meta } = token;
        const object = {
            ...adapter_2.getModuleBase(),
            content: {},
            driver: _contracts_1.ModuleDriver.Embed,
            version: Embed_contracts_1.EmbedVersion.VideoSwitch
        };
        if (typeof content === 'object' && content.videoId) {
            object.content.video = {
                type: services_1.RelatedType.File,
                value: Number(content.videoId)
            };
        }
        if (typeof content === 'object' && content.videoIdOnHash) {
            object.content.videoIdOnHash = content.videoIdOnHash;
        }
        if (typeof content === 'object' && content.videoIdYoutube) {
            object.content.videoIdYoutube = content.videoIdYoutube;
        }
        if (typeof meta !== 'undefined') {
            const { description, thumbnailId } = meta;
            if (typeof description === 'string') {
                object.content.description = description;
            }
            if (typeof thumbnailId === 'number') {
                object.content.thumbnail = {
                    type: services_1.RelatedType.File,
                    value: thumbnailId
                };
            }
        }
        object.content.type = Embed_contracts_1.EmbedVersion.VideoSwitch;
        return object;
    }
}
exports.EmbedVideoSwitchAdapter = EmbedVideoSwitchAdapter;
//# sourceMappingURL=EmbedVideoSwitch.adapter.js.map